import {
  FETCH_CURRENCIES_REQUEST,
  FETCH_CURRENCIES_SUCCESS,
  FETCH_CURRENCIES_FAILURE,
  SAVE_CURRENCY_REQUEST,
  SAVE_CURRENCY_SUCCESS,
  SAVE_CURRENCY_FAILURE,
  DELETE_CURRENCY_REQUEST,
  DELETE_CURRENCY_SUCCESS,
  DELETE_CURRENCY_FAILURE,
} from './types';

const INITIAL_STATE = {
  currencyList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CURRENCIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CURRENCIES_SUCCESS:
      return {
        ...state,
        loading: false,
        currencyList: action.payload,
      };

    case FETCH_CURRENCIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        currencyList: [],
      };
    case SAVE_CURRENCY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_CURRENCY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_CURRENCY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_CURRENCY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_CURRENCY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_CURRENCY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
